module.exports = __webpack_public_path__ + "img/deptManagementFlow.d9962d00.jpg";